<script lang="ts" setup>
import { useWindowSize } from '@vueuse/core'
import { DropdownItem, Icon, Tooltip } from '@brighterly/lib-lumee-ui'

import { AppRoute } from '@ts-routes/enums'

import { useCustomerStore } from '@stores/me/customer'
import { useSubscriptionStore } from '@stores/subscription'

import { useStaticRoutes } from '@composables/routes/static-routes.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import NotificationPointer from '@Atoms/NotificationPointer.vue'

defineOptions({
  name: 'LinkPaymentsSubscriptions',
})

const emit = defineEmits<{
  click: []
}>()

const text = 'Subscription'

const customerStore = useCustomerStore()
const subscriptionStore = useSubscriptionStore()

const route = useRoute()

const {
  isRoutePayments,
  isRoutePaymentsSubscriptions,
  isRoutePaymentsMethods,
  isRoutePaymentsHistory,
} = useStaticRoutes({ route })

const selected = computed(() => {
  return isRoutePayments.value
    || isRoutePaymentsSubscriptions.value
    || isRoutePaymentsMethods.value
    || isRoutePaymentsHistory.value
})

const tooltip = 'Subscriptions will be available after payment'

const {
  width,
} = useWindowSize()

const url = computed(() => {
  return (width.value >= 740)
    ? AppRoute.PaymentsSubscriptions
    : AppRoute.Payments
})

const handleClick = (): void => {
  if (selected.value) return

  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_payments_subscriptions',
    link_text: text,
    href: url.value,
  })
  emit('click')
  void navigateTo(url.value, { external: true })
}

</script>

<template>
  <div class="link-payments-subscriptions">
    <Tooltip
      :description="tooltip"
      size="sm"
      show-when="disabled"
    >
      <DropdownItem
        :title="text"
        role="menuitem"
        :aria-selected="undefined"
        :aria-current="selected ? 'page' : undefined"
        :selected="selected"
        :disabled="customerStore.isTypeDemo"
        @click="handleClick"
      >
        <template #leading>
          <Icon
            name="credit-card"
            size="md"
            :color="customerStore.isTypeDemo ? 'disabled' : 'default'"
          />
        </template>
        <template
          v-if="subscriptionStore.isBannerPaymentRetry"
          #trailingContent
        >
          <NotificationPointer
            view="default"
            color="red"
          />
        </template>
      </DropdownItem>
    </Tooltip>
  </div>
</template>
